// El CSS de Leaflet no viaja con el componente de React: sin este import los
// paneles del mapa se apilan sin posicionar y el mapa se ve roto.
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'
// Leaflet resuelve los iconos por defecto contra una url relativa calculada en
// tiempo de ejecucion, que con un empaquetador apunta a un fichero inexistente
// y deja los marcadores invisibles. Importando las imagenes, Vite las incluye
// en el bundle con su hash y devuelve la url definitiva.
import iconoUrl from 'leaflet/dist/images/marker-icon.png'
import iconoRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import sombraUrl from 'leaflet/dist/images/marker-shadow.png'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import { AvisoError } from '../../componentes/formulario'
import { IconoUbicacion } from '../../componentes/iconos'
import { urlTeselas } from './teselas'


/** Icono explicito: nunca se toca `Icon.Default`, que es el que falla. */
const ICONO_MARCADOR = new Icon({
  iconUrl: iconoUrl,
  iconRetinaUrl: iconoRetinaUrl,
  shadowUrl: sombraUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
})

interface Props {
  nombre: string
  latitud?: number | null
  longitud?: number | null
  onGeocodificar: () => void
  geocodificando: boolean
  error: unknown
  /** RF-48: con la geocodificación apagada no se ofrece el botón (daría 409). */
  geocodificacionApagada?: boolean
}

export function MapaCliente({
  nombre,
  latitud,
  longitud,
  onGeocodificar,
  geocodificando,
  error,
  geocodificacionApagada = false,
}: Props) {
  const tieneCoordenadas = typeof latitud === 'number' && typeof longitud === 'number'

  // Sin coordenadas no hay mapa que pintar: se ofrece la accion que las
  // consigue, en el mismo hueco donde ira el mapa.
  if (!tieneCoordenadas) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-borde-fuerte bg-lienzo px-4 py-8 text-center">
        <IconoUbicacion aria-hidden="true" className="size-8 text-tinta-apagada" />
        <p className="text-sm font-medium text-tinta-2">Este cliente está sin coordenadas</p>
        {geocodificacionApagada ? (
          <p className="max-w-xs text-sm text-tinta-apagada">
            La geocodificación está desactivada. Escribe la latitud y la longitud en la ficha del
            cliente, en la pantalla Clientes.
          </p>
        ) : (
          <>
        <p className="max-w-xs text-sm text-tinta-apagada">
          Se calculan a partir de la dirección y quedan guardadas para las próximas visitas.
        </p>
        <button
          type="button"
          onClick={onGeocodificar}
          disabled={geocodificando}
          className="inline-flex items-center gap-2 rounded-lg bg-acento px-3 py-2 text-sm font-semibold text-tinta-inversa transition-colors hover:bg-acento-fuerte disabled:cursor-not-allowed disabled:bg-desactivado disabled:text-desactivado-tinta"
        >
          <IconoUbicacion aria-hidden="true" className="size-4" />
          <span>{geocodificando ? 'Geocodificando...' : 'Geocodificar'}</span>
        </button>
          </>
        )}
        <AvisoError error={error} />
      </div>
    )
  }

  return (
    // El `region` con nombre es lo que hace localizable el mapa para un lector
    // de pantalla: el `div` que crea Leaflet no lleva nombre accesible.
    <div
      role="region"
      aria-label={`Mapa de ${nombre}`}
      className="overflow-hidden rounded-xl border border-borde"
    >
      <MapContainer
        // MapContainer ignora los cambios de `center` despues de montarse:
        // sin esta clave, cambiar de cliente dejaria el mapa en el anterior.
        key={`${latitud},${longitud}`}
        center={[latitud, longitud]}
        zoom={16}
        scrollWheelZoom={false}
        className="h-64 w-full"
      >
        <TileLayer
          attribution='Mapa <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url={urlTeselas()}
        />
        <Marker position={[latitud, longitud]} icon={ICONO_MARCADOR}>
          <Popup>{nombre}</Popup>
        </Marker>
      </MapContainer>
    </div>
  )
}
